// extracted by mini-css-extract-plugin
module.exports = {"menuApp":"MenuPage_menuApp__3DJUo","menuLinkList":"MenuPage_menuLinkList__1ab0N"};